export const CLASSES = {
  major: { label: "Major airport", color: "#E11D48" },
  certified: { label: "Certified", color: "#059669" },
  airstrip: { label: "Airstrip", color: "#0284C7" },
  heliport: { label: "Heliport", color: "#D97706" },
  defence: { label: "Defence", color: "#334155" },
};

export const STATES = ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "NT", "ACT"];

export const classOf = (a) => CLASSES[a?.aero_class] ?? { label: a?.aero_class || "Other", color: "#94A3B8" };

export const parsePls = (raw) => {
  const list = Array.isArray(raw) ? raw : raw?.airfields ?? raw?.locations ?? [];
  const rows = (Array.isArray(list) ? list : []).filter((a) => Number.isFinite(Number(a?.lat)) && Number.isFinite(Number(a?.lng)));
  return { meta: Array.isArray(raw) ? {} : { source: raw?.source, generated_at: raw?.generated_at, count: raw?.count }, rows };
};

export const filterRows = (rows, { q, states, classes, ersaOnly }) => {
  const needle = q.trim().toLowerCase();
  return rows.filter((a) => {
    if (states.length && !states.includes(a.state || "—")) return false;
    if (classes.length && !classes.includes(a.aero_class)) return false;
    if (ersaOnly && !a.ersa) return false;
    if (!needle) return true;
    return [a.name, a.icao, a.iata, a.municipality].some((v) => (v || "").toLowerCase().includes(needle));
  });
};

export const countBy = (rows, key) => rows.reduce((acc, r) => {
  const k = r?.[key] || "—";
  acc[k] = (acc[k] || 0) + 1;
  return acc;
}, {});

export const toCsv = (rows) => {
  const cols = ["airfield_id", "name", "icao", "iata", "aero_class", "state", "municipality", "lat", "lng", "ersa", "is_heliport"];
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  return [cols.join(","), ...rows.map((r) => cols.map((c) => esc(r[c])).join(","))].join("\n");
};
